import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { Announcement } from '../types/announcements';
import { request } from './http';

interface AnnouncementResponse {
	id: number;
	title: string;
	description: string;
	authorId: number;
	authorName: string;
	createdAt: string;
	updatedAt: string;
}

const formatPublishedDate = (value: string): string => {
	const formatted = dayjs(value).locale('es').format('MMMM D, YYYY');
	return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

export const createAnnouncement = (body: {
	title: string;
	description: string;
}): Promise<AnnouncementResponse> =>
	request<AnnouncementResponse>('/api/announcements', {
		method: 'POST',
		body: JSON.stringify(body),
	});

export const updateAnnouncement = (
	id: number,
	body: { title: string; description: string }
): Promise<AnnouncementResponse> =>
	request<AnnouncementResponse>(`/api/announcements/${id}`, {
		method: 'PUT',
		body: JSON.stringify(body),
	});

export const deleteAnnouncement = (id: number): Promise<void> =>
	request<void>(`/api/announcements/${id}`, { method: 'DELETE' });

export const listAnnouncements = async (): Promise<Announcement[]> => {
	const rows = await request<AnnouncementResponse[]>('/api/announcements');
	return rows.map((row) => ({
		id: row.id,
		title: row.title,
		description: row.description,
		date: formatPublishedDate(row.createdAt),
	}));
};
